const PLAN_NAMES = {
  START: "Start",
  PRO: "Pro",
  PREMIUM: "Premium",
  INSIDER: "Insider"
};

export default PLAN_NAMES;
